import { Box, Typography, IconButton } from "@mui/material";
import { useWindowSize } from "../../../utils/useWindowSize";

// CSS
import "./KeywordReportTitle.css";
import { useEffect, useState } from "react";

interface propsType {
  strategy: any;
  index: number;
}

const KeywordReportInsight = (props: propsType) => {
  const windowSize = useWindowSize();
  const [textMaxWidth, setTextMaxWidth] = useState(1000);

  useEffect(() => {
    let maxWidth = windowSize.width - (windowSize.width > 1023 ? 280 : 140);
    setTextMaxWidth(maxWidth > 910 ? 910 : maxWidth);
  }, [windowSize]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // "&:hover": { backgroundColor: "rgba(208, 255, 0, 1)" },
      }}
    >
      <Box>
        <Box sx={{ display: "flex", flexDirection: "row", gap: "8px", marginBottom: "8px" }}>
          <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", color: "rgba(42, 42, 42, 1)" }}>
            {"•"}
          </Typography>
          <Typography
            sx={{
              // maxWidth: `${textMaxWidth}px`,
              fontSize: "1rem",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            {props.strategy}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default KeywordReportInsight;
